/**
 * @ignore
 * Created by daletan on 9/7/16.
 */

'use strict';

const convertedAmountsString = `
    USD
    GBP
    EUR
    CAD
    AUD
    CHF
    MXN
`;

const actionsQuery = `
    actions {
        apiType
        code
    }
`;

const returnPolicyQuery = `
    returnPolicy {
        id
        name
        accept
        note
        notifyDays
        sellerKey {
            id
            vertical
        }
    }
`;

const lowestShipmentQuoteQuery = `
    lowestShipmentQuote {
        id
        complimentaryShipping
        totalAmount {
            amount
            convertedAmounts {
                ${convertedAmountsString}
            }
        }
    }
`;

const pricesQuery = `
    prices {
        type
        hidePrice
        negotiable
        pricePerPiece
        status
        amount {
            apiType
            currency
            amount
            convertedAmounts {
                ${convertedAmountsString}
            }
        }
    }
`;

const priceLocksQuery = `
    priceLocks {
        id
        lockType {
            name
        }
        price {
            amount {
                convertedAmounts {
                    ${convertedAmountsString}
                }
            }
        }
    }
`;

const pricingQuery = `
    pricing {
        negotiable
        hidePrice
        pricePerPiece
        totalAmount {
            amount
            currency
        }
        ${pricesQuery}
        ${priceLocksQuery}
    }
`;

const holdsQuery = `
    activeHold {
        id
        buyer {
            serviceId
        }
        status
        expirationDate
    }
`;

const shipmentQuotesFragment = `
    edges {
        node {
            handlingTimeDisplay
            totalAmount {
                currency
                amount
                convertedAmountList {
                    currency
                    amount
                }
            },
            is1stdibsWhiteGloveQuote
            serviceMethod {
                serviceMethodType
                displayName
                region {
                    apiType
                    code
                    regionName
                    regionType
                }
            }
        }
   }
`;

const query = (pk, userId, hasUserId) => {
    if (!pk) {
        console.warn(`a valid pk must be passed in. ${pk} was given`);
        return false;
    }

    return `{
        viewer {
            item(itemId:"${pk}") {
                vertical
                title
                pieces
                status
                isSold
                isOnHold
                unavailableReasonCode
                canMakePurchase
                pieces
                ${holdsQuery}
                ${actionsQuery}
                ${returnPolicyQuery}
                ${lowestShipmentQuoteQuery}
                ${pricingQuery}
            }
            shipmentQuotes(itemId: "${pk}", searchView: PDP) {
                ${shipmentQuotesFragment}
            }
            localDeliveryOptions: availableDeliveryOptions(itemId: "${
                pk
            }", regionView: LOCAL, addressResolutionType: IP) {
                ${shipmentQuotesFragment}
            }
            domesticDeliveryOptions: availableDeliveryOptions(itemId: "${
                pk
            }", regionView: DOMESTIC, addressResolutionType: IP) {
                ${shipmentQuotesFragment}
            }
            user(userId: "${userId}") @include(if: ${hasUserId}) {
                canRequestShippingQuote: hasPermission(name: "B_REQUEST_SHIPPING_QUOTE")
            }
        }
    }`;
};

module.exports = {
    query,
};



// WEBPACK FOOTER //
// ./assets/js/global/headItemQuery.es.js